export const flightDate = (date: string) => {
  const dateObj = new Date(date.split('T')[0].replaceAll('-', '/'))

  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ]

  const day = dateObj.getDate()

  const month = months[dateObj.getMonth()]

  const year = dateObj.getFullYear()

  return month + ' ' + day + ', ' + year
}

const NOON = 12
const HOURS_IN_HALF_DAY = 12

export const flightTime = (date: string) => {
  const timePart = date.split('T')[1]?.replace('Z', '') ?? '00:00:00'
  const [hoursStr, minutesStr] = timePart.split(':')
  const hours = parseInt(hoursStr, 10)
  const minutes = minutesStr
  const period = hours >= NOON ? 'PM' : 'AM'
  const hours12 = hours % HOURS_IN_HALF_DAY || HOURS_IN_HALF_DAY
  return `${hours12}:${minutes} ${period}`
}
